"use strict";
/* eslint-disable no-control-regex */
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowListAccountNameCharRegex = exports.allowListCompanyNameCharRegex = exports.allowListPersonNameRegex = exports.allowListSingleLineCharRegex = exports.allowListMultiLineCharRegex = exports.textNoWhiteSpacesRegex = exports.textMultipleWhiteSpace = void 0;
/**
 * Regex that validates text
 *
 * - Checks more than single white space (e.g. 'a  b', 'a   b')
 */
exports.textMultipleWhiteSpace = /\s\s+/;
/**
 * Regex that validates text
 *
 * - Forbids all spaces in the text (e.g. 'a b', ' ab')
 */
exports.textNoWhiteSpacesRegex = /^\S*$/;
/**
 * Most comment latin characters and numbers. Base for all regexes.
 *
 * - a-z A-Z (latin letters)
 * - À-ȕ (accented latin letters)
 * - 0-9 (numbers)
 */
const alphaNumericAccentChars = "a-zÀ-ȕ0-9";
/**
 * Regex that validates multi-line text
 *
 * - Match alphaNumericAccentChars
 * - Match special chars:[ !] and char range from # to ~ (excl. ["])
 * - Match line breaks: new line, new line ASCII char
 */
exports.allowListMultiLineCharRegex = new RegExp(`^[${alphaNumericAccentChars} !#-~\n\x0C]+$`, "i");
/**
 * Regex that validates single-line text
 *
 * - Match alphaNumericAccentChars
 * - Match special chars: [ ,.-_!/]
 */
exports.allowListSingleLineCharRegex = new RegExp(`^[${alphaNumericAccentChars} ,.\\-_!/]+$`, "i");
/**
 * Regex that validates person names
 *
 * - Match alphaNumericAccentChars
 * - Match special chars: [ ,.-']
 */
exports.allowListPersonNameRegex = new RegExp(`^[${alphaNumericAccentChars} ,.'\\-]+$`, "i");
/**
 * Regex that validates company names
 *
 * - Match alphaNumericAccentChars
 * - Match special chars: [ ,.-_!&()+'/]
 */
exports.allowListCompanyNameCharRegex = new RegExp(`^[${alphaNumericAccentChars} ,.\\-_!&()+'/]+$`, "i");
/**
 * Regex that validates account names
 *
 * - Match alphaNumericAccentChars
 * - Match special chars: [ §!] and char range from # to ~ (excl. ["])
 */
exports.allowListAccountNameCharRegex = new RegExp(`^[${alphaNumericAccentChars} §!#-~]+$`, "i");
